import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
export default {
  __name: 'QboIcon',
  props: {
    size: {
      type: [Number, String],
      default: 16
    }
  },
  setup(__props) {
    // Shared QuickBooks logo, matching the existing `/img/qb16x16.png` convention
    // used across the app's "Open in QuickBooks" affordances.

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("img", {
        src: "/img/qb16x16.png",
        alt: "QuickBooks",
        width: __props.size,
        height: __props.size,
        class: "align-middle"
      }, null, 8, _hoisted_1);
    };
  }
};